import * as Yup from 'yup'
import { FORM_LABELS, LABELS } from '@constants'
import { createEmailValidator } from '@utilities/validation'

export const validationSchema = () =>
  Yup.object().shape({
    name: Yup.string().required(FORM_LABELS.REQUIRED(LABELS.NAME)),
    email: createEmailValidator(FORM_LABELS.INVALID(LABELS.EMAIL)).required(FORM_LABELS.REQUIRED(LABELS.EMAIL)),
    password: Yup.string()
      .required(FORM_LABELS.REQUIRED(LABELS.PASSWORD))
      .min(8, FORM_LABELS.PASSWORD_MIN_LENGTH)
      .matches(/[A-Z]/, FORM_LABELS.PASSWORD_UPPERCASE_REQUIRED)
      .matches(/[a-z]/, FORM_LABELS.PASSWORD_LOWERCASE_REQUIRED)
      .matches(/[0-9]/, FORM_LABELS.PASSWORD_NUMBER_REQUIRED),
    password_confirmation: Yup.string()
      .required(LABELS.CONFIRM_PASSWORD_REQUIRED)
      .oneOf([Yup.ref('password')], LABELS.CONFIRM_PASSWORD_DOES_NOT_MATCH),
  })
